import React from 'react';
import '../styles/alert.css';

const Confirm = ({ title, message, onConfirm, onCancel, confirmLabel, confirmStyle }) => {
  const btnStyle = confirmStyle
    ? { border: '1px solid', ...confirmStyle }
    : { background: 'rgba(239,68,68,0.15)', color: '#f87171', border: '1px solid rgba(239,68,68,0.3)' };
  return (
    <div className="alert-overlay">
      <div className="alert-box" onClick={(e) => e.stopPropagation()}>
        <div className="alert-icon-circle alert-icon-warning">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <h3 className="alert-title">{title || 'Confirmar acción'}</h3>
        <p className="alert-message">{message}</p>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            className="alert-btn"
            style={{ background: 'rgba(255,255,255,0.08)', color: '#cbd5e1' }}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button className="alert-btn" style={btnStyle} onClick={onConfirm}>
            {confirmLabel || 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Confirm;
